import "./ruled_specs.css";
